module.exports = __webpack_public_path__ + "static/media/hamp.daf1eb10.jpg";